var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"padded"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{name: 'adminUsers'}}},[_vm._v("Users")])],1)]),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }